import WurldDynamicTag from './Helpers/WurldDynamicTag.vue';

export default {
	WurldDynamicTag
};
